<template>
  <div class="order-result">
    <div class="order-result__title">Заказ оформлен!</div>
    <div class="order-result__text">
      Ожидайте доставку заказа
    </div>
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss">
  .order-result {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 24px 40px 24px;
    &__title {
      font-size: 26px;
      line-height: 28px;
      font-weight: 700;
      margin-bottom: 20px;
    }

    &__text {
      font-size: 16px;
      line-height: 22px;
      font-weight: 400;
    }
  }
</style>
